import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultFieldset: {
    id: 'defaultFieldset',
    defaultMessage: 'default',
  },
  ShowBioHeaderTitle: {
    id: 'ShowBioHeader',
    defaultMessage: 'Show Biography headline',
  },
  ShowBioHeaderDescription: {
    id: 'ShowBioDescription',
    defaultMessage:
      'Show Biography headline regardless if there is bio data or not',
  },
});

export const personMetadataSchema = (props) => {
  const { intl } = props;

  return {
    title: 'Metadata of Person',
    description: '',
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.defaultFieldset),
        fields: ['showBioHeadline'],
      },
    ],
    properties: {
      showBioHeadline: {
        title: intl.formatMessage(messages.ShowBioHeaderTitle),
        description: intl.formatMessage(messages.ShowBioHeaderDescription),
        type: 'boolean',
        defaultValue: false,
      },
    },
    required: [],
  };
};

export default personMetadataSchema;
